import React from 'react';
import classNames from 'classnames';
import DisplayCurrencyPicker from '#components/Elements/DisplayCurrencyPicker/DisplayCurrencyPicker';
import styles from './HeaderTitle.scss';

export default function HeaderTitle({
  className,
  children,
  showCurrencyPicker = false,
}) {
  return (
    <div
      className={classNames(styles.HeaderTitle, className, {
        [styles.withCurrencyPicker]: showCurrencyPicker,
      })}
    >
      {children}

      {showCurrencyPicker && (
        <>
          <div className={styles.currencyPickerMobile}>
            <DisplayCurrencyPicker compact />
          </div>

          <div className={styles.currencyPickerDesktop}>
            <DisplayCurrencyPicker />
          </div>
        </>
      )}
    </div>
  );
}
